import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import LogoFull from '@panel/commons/assets/icons/benvi_i24_full.svg';
import {
  InfoWrapper,
  OperationInfo,
  TitleContainerFUll,
  StatusTagFULL,
  LogoFullContainer,
  PropertyType,
  AddressContainerFull,
  OperationType
} from './styles';

function InfoConvertedFull({
  propertyType = '',
  address = '',
  pricesOperationTypes = [],
  openDetailPosting,
  isRented
}) {
  const { t } = useTranslation();
  const [priceAndOperation] = pricesOperationTypes;

  return (
    <InfoWrapper>
      <div onClick={openDetailPosting} aria-hidden='true'>
        <OperationInfo>
          <LogoFullContainer src={LogoFull} alt='LogoFull' data-panel='posting-logo-full' />
          {isRented && (
            <StatusTagFULL type='Rentado' data-panel='posting-state-rented-full'>
              {t('panel.avisos.posting.isTargetFull.rented.mobile')}
            </StatusTagFULL>
          )}
        </OperationInfo>
        <TitleContainerFUll data-panel='posting-title-full'>
          {t('panel.avisos.posting.isTargetFull.published.mobile')}
          <span>{t('panel.avisos.posting.isTargetFull.published.full.mobile')}</span>
        </TitleContainerFUll>
        <PropertyType>{propertyType}</PropertyType>
        <AddressContainerFull data-panel='posting-address-full'>{address}</AddressContainerFull>

        <OperationType
          data-panel={`posting-priceInfo-${t(`postings.card.operationType.${priceAndOperation.operationType}`)}`}
        >
          {t(`postings.card.operationType.${priceAndOperation.operationType}`)}
        </OperationType>
      </div>
    </InfoWrapper>
  );
}

export default InfoConvertedFull;
